import { Alert, AlertDescription, AlertIcon, Stack, Text, useColorModeValue } from '@ecoinvent/ui';

import { DatasetRef } from 'components/shared/Compare';

const releaseLabel = ({ version, systemModel }: DatasetRef) => `${version}-${systemModel}`;

export const describeReleases = (refs: (DatasetRef | undefined)[]): string =>
  refs.flatMap((ref) => (ref ? [releaseLabel(ref)] : [])).join(' and ');

export const CrossVersionCaveat = ({ refs }: { refs: (DatasetRef | undefined)[] }) => (
  <Alert status="info" variant="left-accent" borderRadius="md">
    <AlertIcon />
    <AlertDescription fontSize="sm">
      Comparing {describeReleases(refs)}. Characterisation factors and background data change between releases, so part of any
      difference comes from the release rather than the datasets.
    </AlertDescription>
  </Alert>
);

export const CrossReleaseNotice = ({ title, children }: { title: string; children: React.ReactNode }) => {
  const bg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const grayText = useColorModeValue('gray.600', 'gray.400');

  return (
    <Stack align="center" justify="center" spacing={3} bg={bg} borderRadius="md" py={16} px={6} textAlign="center">
      <Text fontWeight="semibold" color={grayText}>
        {title}
      </Text>
      <Text fontSize="sm" color={grayText} maxW="34em">
        {children}
      </Text>
    </Stack>
  );
};
